import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import type { RootState } from './store'; // <-- import your store's RootState
import {
  addService,
  removeService,
  clearAllSelectedServices,
  toServiceAnalytics,
} from '../features/serviceTypes/serviceTypesSlice';
import { mp, getDistinctId } from '../util/analytics';
import { aprTrack, planForBasket } from '../util/aperioTracking';
import { getSkin } from '../consumer/skin';
import {
  addAddOn,
  clearAllAddOns,
  removeAddOn,
} from '../features/addOns/addOnsSlice';

let timer: ReturnType<typeof setTimeout> | null = null;
let lastPlan: string | null = null;
const debounce = (fn: () => void, delay = 350) => {
  if (timer) clearTimeout(timer);
  timer = setTimeout(fn, delay);
};

export const servicesAnalyticsListener = createListenerMiddleware();

servicesAnalyticsListener.startListening({
  matcher: isAnyOf(addService,
    removeService,
    clearAllSelectedServices,
    addAddOn,
    removeAddOn,
    clearAllAddOns),
  effect: (action, api) => {
    debounce(() => {
      const state = api.getState() as RootState;
      const services = state?.serviceTypes?.services ?? [];
      const addOns = state?.addOns?.addOns ?? [];

      const payload = {
        ...toServiceAnalytics([...services, ...addOns]),
        is_logged_in: !!state.auth?.isAuthenticated,
        anon_id: getDistinctId(),
        path: typeof window !== 'undefined'
          ? window.location.pathname : undefined,
      };

      mp.track('Services - Selection Updated', payload);

      // Aperio contract event (no-op for other tenants): when the plan in
      // the basket changes. The consumer skin sends it itself, from the
      // customer's click only (consumer/steps/PlanStep.tsx): its basket
      // also changes on page load and twice per toggle.
      const plan = planForBasket(services.map((service) => service.nameKey));
      if (plan && plan !== lastPlan && getSkin() !== 'consumer') {
        aprTrack('plan_select', { plan });
      }
      lastPlan = plan;
    });
  },
});
